import isEmpty from 'lodash/isEmpty'

import { getDataFromState, getStateFromData } from '@components/CommandParameters/helpers'

import { ENTITY_COMMAND_TYPE, TYPES_SOURCE_OPTIONS } from '@constants'
import { EntityCommandDTO } from '@types'

import { GanttFormCommands } from '@gantt/components/GanttCreateOrEdit'
import { EMPTY_COMMAND_FORM } from '@gantt/constants'

export const getCommandsFormattedRequest = (commands: GanttFormCommands): EntityCommandDTO[] => {
  return (commands as GanttFormCommands).map(command => ({
    httpMethod: command.httpMethod as string,
    type: command.type?.label as ENTITY_COMMAND_TYPE,
    name: command.name?.label as string,
    resource: command.sourceType?.id as TYPES_SOURCE_OPTIONS,
    objectCode: command.sourceCommand?.id as string,
    objectTitle: command.sourceCommand?.label as string,
    parameters: getDataFromState(command.parameters),
    body: getDataFromState(command.body),
  }))
}

export const getCommandsFormattedResponse = (
  commands: EntityCommandDTO[],
  emptyValue?: any
): GanttFormCommands => {
  if (isEmpty(commands)) {
    return emptyValue !== undefined ? emptyValue : EMPTY_COMMAND_FORM
  }

  return commands.map(command => ({
    httpMethod: command.httpMethod,
    type: { id: command.type, label: command.type },
    name: { id: command.name, label: command.name },
    sourceType: { id: command.resource, label: command.resource },
    sourceCommand: { id: command.objectCode, label: command.objectTitle },
    parameters: getStateFromData(command.parameters),
    body: getStateFromData(command.body),
  }))
}
